import React from "react";
import "./home.less";
import Banner from "@/assets/img/banner.jpg";

import Footer from "@/components/Footer";
import Page1 from "@/components/Page1";
import Page2 from "@/components/Page2";
import Page3 from "@/components/Page3";
import Page4 from "@/components/Page4";

const Home: React.FC = () => {
  return (
    <div className="home">
      <div className="banner">
        <img src={Banner} alt="banner" />
      </div>
      <section className="content">
        <Page1 />
        <Page2 />
        <Page3 />
        <Page4 />
      </section>
      <Footer />
    </div>
  );
};

export default Home;
